export const roles = {
    admin: 'ROLE_CUSTOMER_ADMIN',
    adminNoExport: 'ROLE_CUSTOMER_ADMIN_NO_EXPORT',
    superAdmin: 'ROLE_ADMIN', // noi
    userWithSub: 'ROLE_USER_ABO',
    user: 'ROLE_USER',
    masi: 'ROLE_MASI_ABO'
}

export const statuses = {
    disabled: 'DISABLED',
    enabled: 'ENABLED',
    confirmed: 'CONFIRMED',
    registered: 'REGISTERED'
}

export const newsletters = {
    newsletter: 'Newsletter',
    newsletter_1: 'Promozioni',
    newsletter_2: 'Promozioni personalizzate',
}